import React from 'react';
import { Fab } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsAppButton = () => {
  const whatsappNumber = '917979966901'; // Replace with actual number
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=Hello%20Kavya%20Institute`;

  return (
    <Fab
      color="success"
      aria-label="whatsapp"
      sx={{
        position: 'fixed',
        bottom: 30,
        right: 30,
        backgroundColor: '#25D366',
        '&:hover': {
          backgroundColor: '#1fa754',
        },
      }}
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      <WhatsAppIcon sx={{ color: 'white', fontSize: '2rem' }} />
    </Fab>
  );
};

export default WhatsAppButton;
